import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import PanelContent from '@portal/components/PanelContent/PanelContent';

import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';

import ExtractPage from './ExtractPage/ExtractPage';
import { PageClass } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';

const ExtractNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.EXTRACT,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('EXTRACT', 'EXTRACT_PAGE')}>
        <PanelContent pageTitle={translate('PAGES.EXTRACT.TITLE')}>
          <ExtractPage />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default ExtractNavigationStack;
